import { render } from "./uiPageSectionBoxFollowLink.vue?vue&type=template&id=7aaceb78"
import script from "./uiPageSectionBoxFollowLink.vue?vue&type=script&lang=js"
export * from "./uiPageSectionBoxFollowLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__